const SettingsPortalCustomTagsTypePolicy = {
  SettingsPortalCustomTagsResponse: {
    keyFields: false,
  },
  SettingsPortalCurriculumProgramTags: {
    keyFields: false,
  },
  SettingsPortalCurriculumProgramAclPermission: {
    keyFields: ({ controlParameterId }) => controlParameterId,
  },
  SettingsPortalCurriculumProgramConfiguration: {
    keyFields: ({ configurationId }) => configurationId,
  },
  SettingsPortalGradeTags: {
    keyFields: false,
  },
  SettingsPortalGradeItem: {
    keyFields: false,
  },
  SettingsPortalCurriculumProgramItem: {
    keyFields: false,
  },
  SettingsPortalGradeAclPermission: {
    keyFields: ({ controlParameterId }) => controlParameterId,
  },
  SettingsPortalGradeConfiguration: {
    keyFields: ({ configurationId }) => configurationId,
  },
};

export default SettingsPortalCustomTagsTypePolicy;
